<div class="toggler">
  <label class="switch" for="toggeler">
    <input
      id="toggeler"
      type="checkbox"
      [checked]="value"
      [attr.data-pername]="attrName"
      (change)="change()"
      [(ngModel)]="value"
      [disabled]="disabled || readonly"
    />
    <!-- <span class="slider round"></span> -->
  </label>
  <div class="text">
    <p>{{ title }}</p>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="error" *ngIf="ShowError" style="margin-top: 8px">
      <validations [control]="control"></validations>
    </div>
  </div>
</div>
